"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "breakpoints", {
  enumerable: true,
  get: function get() {
    return _fuseResponsiveGrid.gridConfig;
  }
});
Object.defineProperty(exports, "colours", {
  enumerable: true,
  get: function get() {
    return _fuseColours["default"];
  }
});
Object.defineProperty(exports, "convertRemToPx", {
  enumerable: true,
  get: function get() {
    return _fuseTypography.convertRemToPx;
  }
});
Object.defineProperty(exports, "elevation", {
  enumerable: true,
  get: function get() {
    return _fuseElevation["default"];
  }
});
Object.defineProperty(exports, "globalSpacingTokens", {
  enumerable: true,
  get: function get() {
    return _fuseSpacing.globalSpacingTokens;
  }
});
Object.defineProperty(exports, "spacing", {
  enumerable: true,
  get: function get() {
    return _fuseSpacing.spacing;
  }
});
exports.typography = void 0;
var _fuseColours = _interopRequireDefault(require("@tvg/fuse-colours"));
var _fuseElevation = _interopRequireDefault(require("@tvg/fuse-elevation"));
var _fuseResponsiveGrid = require("@tvg/fuse-responsive-grid");
var _fuseSpacing = require("@tvg/fuse-spacing");
var _fuseTypography = require("@tvg/fuse-typography");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var typography = exports.typography = _objectSpread(_objectSpread({}, _fuseTypography.defaultCssProps), {}, {
  fontColor: {
    display: (0, _fuseTypography.display)(_fuseTypography.themeName.very).fontColor,
    heading: (0, _fuseTypography.display)(_fuseTypography.themeName.very).fontColor,
    paragraph: (0, _fuseTypography.paragraph)(_fuseTypography.themeName.very).fontColor
  },
  fontFamilyLittlewoods: _fuseTypography.fontFamily[_fuseTypography.themeName.littlewoods],
  fontFamilyVery: _fuseTypography.fontFamily[_fuseTypography.themeName.very],
  fontWeight: {
    display: (0, _fuseTypography.display)(_fuseTypography.themeName.very).fontWeight,
    heading: (0, _fuseTypography.display)(_fuseTypography.themeName.very).fontWeight,
    paragraph: (0, _fuseTypography.paragraph)(_fuseTypography.themeName.very).fontWeight
  },
  themeNameVery: _fuseTypography.themeName.very,
  themeNameLittlewoods: _fuseTypography.themeName.littlewoods
});